/**
 * Rates.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

module.exports = {

    // tableName: 'rates',

    attributes: {

      //  ╔═╗╦═╗╦╔╦╗╦╔╦╗╦╦  ╦╔═╗╔═╗
      //  ╠═╝╠╦╝║║║║║ ║ ║╚╗╔╝║╣ ╚═╗
      //  ╩  ╩╚═╩╩ ╩╩ ╩ ╩ ╚╝ ╚═╝╚═╝

      customer: {
        model: 'customer',
        required: true
      },

      billType: {
        model: 'billtype',
        required: true,
      },

      origin: {
        model: 'location',
        required: true
      },

      destination: {
        model: 'location',
        required: true
      },

      dispatchtype: {
        model: 'dispatchtype',
        required: true
      },

      vehicletype: {
        model: 'vehicletype',
        required: true
      },

      amount: {
        type: 'number',
        required: true
      },

      currency: {
        type: 'string',
        required: true
      },

      supplierCost: {
        type: 'number',
      },

      supplierCurrency: {
        type: 'string',
      },

      dueDate: {
        type: "ref",
        columnType: "datetime",
      },

      //  ╔═╗╔╦╗╔╗ ╔═╗╔╦╗╔═╗
      //  ║╣ ║║║╠╩╗║╣  ║║╚═╗
      //  ╚═╝╩ ╩╚═╝╚═╝═╩╝╚═╝


      //  ╔═╗╔═╗╔═╗╔═╗╔═╗╦╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
      //  ╠═╣╚═╗╚═╗║ ║║  ║╠═╣ ║ ║║ ║║║║╚═╗
      //  ╩ ╩╚═╝╚═╝╚═╝╚═╝╩╩ ╩ ╩ ╩╚═╝╝╚╝╚═╝

    //   originDispatches: {
    //     collection: 'dispatch',
    //     via: 'origin'
    //   },

    //   destinationDispatches: {
    //     collection: 'dispatch',
    //     via: 'destination'
    //   },

    },

  };




// WEBPACK FOOTER //
// ./src/models/Rates.js